import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { RecalculateSetting } from './recalculate-settings.model';

export const entityName = 'CompanySetting';

@Injectable()
export class RecalculateSettingsDataService extends EfaactDataService<RecalculateSetting> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }
    mapItems(item: RecalculateSetting): RecalculateSetting {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.SettingType
        };
    }
}
